import { AxiosInstance } from 'axios'

const loadingService = new class LoadingService {
  private pendingRequests = 0
  private loadingBar: any

  setLoadingBar (loadingBar: any) {
    this.loadingBar = loadingBar
    if (this.pendingRequests > 0) {
      this.loadingBar.loading = true
    } else {
      this.loadingBar.loading = false
    }
  }

  increaseRequests () {
    this.pendingRequests++
    if (this.pendingRequests > 0 && this.loadingBar) {
      this.loadingBar.loading = true
    }
  }

  decreaseRequests () {
    this.pendingRequests--
    if (this.pendingRequests === 0 && this.loadingBar) {
      this.loadingBar.loading = false
    }
  }

  setupInterceptors (http: AxiosInstance) {
    http.interceptors.request.use(config => {
      this.increaseRequests()
      return config
    })

    http.interceptors.response.use(
      res => {
        this.decreaseRequests()
        return res
      },
      err => {
        this.decreaseRequests()
        throw err
      }
    )
  }
}

export default loadingService
